import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// Material
import Typography from "@material-ui/core/Typography";
// Controls
import Btn from "./../../Controls/Button/Button";
// Custom Hooks
import usePriceSummary from "./../../../CustomHooks/usePriceSummary";
import useProductPrice from "./../../../CustomHooks/useProductPrice";
import useProduct from "./../../../CustomHooks/useProduct";
import useCheckoutForm from "../../../CustomHooks/useCheckoutForm";
// Styles
import useStyles from "./CartPopover.style.js";
import { CURRENCY } from "../../../utils/Constants";
import { useState } from "react";
import { useEffect } from "react";
import { setNoOrderType } from "../../../store/Restaurant/RestaurantActions.js";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min.js";
import useDynamicHotelData from "../../../CustomHooks/useDynamicHotelData.js";
import { dispatchErrorMessageAsWarning } from "../../../utils/Shared.js";
import { showSnackbarAction } from "../../../store/Snackbar/SnackbarAction.js";
import { shouldDisableCartButtons } from "../../../utils/orderValidation.js";
import useTimeServices from "../../../CustomHooks/useTimeServices";
import useScheduledSlots from "../../../CustomHooks/useScheduledSlots";

export default function CartPopover() {
  const classes = useStyles();
  const state = useSelector((state) => state.cart);
  const { hotelKey, hotel,isTodayHoliday, tableId } = useSelector((state) => state.hotel);
  const priceSummary = usePriceSummary();
  const { getOriginalPrice, getItemTotalPrice } = useProduct();
  const [isBtnDisabled, setIsBtnDisabled] = useState(false);
  const timeServices = useTimeServices();
  const scheduledSlots = useScheduledSlots();
  const { formValues } = useCheckoutForm();
  const { nextAvailableTime } = useSelector((state) => state.time);
  const dispatch = useDispatch();
  const history = useHistory();
  const { hotelStatus,getOrderTypes,hotelOrderStatus } =
  useDynamicHotelData();

  // Check if cart buttons should be disabled
  const isCartDisabled = shouldDisableCartButtons(
    formValues, 
    hotel, 
    tableId, 
    timeServices, 
    scheduledSlots, 
    hotelStatus.active, 
    isTodayHoliday,
    formValues?.orderType
  );

  // Cart buttons are now properly disabled based on order selection validity

  useEffect(() => {
    if (!tableId) {
      // if (
      //   formValues.orderType === null ||
      //   (hotel?.openingAvailable === false && hotel?.is_preorder === 0) ||
      //   nextAvailableTime === null
      // ) {
      //   setIsBtnDisabled(true);
      // }
      if (
        formValues?.orderType === "DELIVERY" &&
        hotel?.deliveryAvailable === false &&
        hotel?.is_preorder === 0
      ) {
        setIsBtnDisabled(true);
      }
      if (
        formValues?.orderType === "PICKUP" &&
        hotel?.pickupAvailable === false &&
        hotel?.is_preorder === 0
      ) {
        setIsBtnDisabled(true);
      }
    }
  }, [formValues.orderType, hotel, tableId]);

  const handleBtnClick = () => {
    // Check if cart should be disabled based on our validation logic
    if (isCartDisabled) {
      return;
    }

    const isEmptyObject = (obj) => {
      return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
    };
    if (
      (formValues?.orderType === null || formValues?.deliveryTime === null||isEmptyObject(formValues)) &&
      tableId == null
    ) {

      // setDrawerOpen(true);
      dispatch(setNoOrderType(true));
      // setOrderTypeModal(true);
    } else if (hotel?.openingAvailable === false && hotel?.is_preorder === 0) {

      dispatchErrorMessageAsWarning({
        title: "Alert",
        message:
          "we are currently closed. Kindly revisit during our designated opening hours.",
      });
    } else if (nextAvailableTime === null && getOrderTypes == []) {

      dispatchErrorMessageAsWarning({
        title: "Warning",
        message:
          "Unfortunately, we have ceased operations for today. We kindly request that you return tomorrow.",
      });
    } else if (
      formValues?.orderType === "DELIVERY" &&
      hotel?.deliveryAvailable === false &&
      hotel?.is_preorder === 0
    ) {

      dispatchErrorMessageAsWarning({
        title: "Warning",
        message: "Delivery time is currently Finished",
      });
    } else if (
      formValues?.orderType === "PICKUP" &&
      hotel?.pickupAvailable === false &&
      hotel?.is_preorder === 0
    ) {

      dispatchErrorMessageAsWarning({
        title: "Warning",
        message: "Pickup time is currently finished",
      });
    } else {
      if (!hotelOrderStatus) {

        dispatch(
          showSnackbarAction(
            hotel?.online_inactive_reason || "Shop is temporarily closed",
            "warning"
          )
        );
        return true;
      }
      if (state.data.length === 0) {

        dispatch(showSnackbarAction("Cart is empty", "warning"));
        return true;
      }

      history.push(`/${hotelKey}/cart`);
    }
  };

  return (
    <div className={classes.container}>
      <div className={classes.OderListContainer}>
        {state.data.map((c, i) => (
          <CartPopoverItem key={i} cartItem={c} />
        ))}
        <div className={classes.totalContainer}>
          <Typography className={classes.text}>Total</Typography>
          <div className={classes.grow} />
          <Typography className={classes.text}>
            {CURRENCY.SIGN}
            {getOriginalPrice(priceSummary.total)}
          </Typography>
        </div>
        {/* <Link to={`/${hotelKey}/cart`}> */}
        <Btn
          disabled={isCartDisabled}
          text={"Go to Cart"}
          className={classes.btn}
          handleClick={handleBtnClick}
        />
        {/* </Link> */}
      </div>
    </div>
  );
}

function CartPopoverItem({ cartItem }) {
  const classes = useStyles();
  const { total } = useProductPrice(cartItem._cartItemId);
  const { getOriginalPrice, getItemTotsalPrice } = useProduct();
  return (
    <div className={classes.OderListItemContainer}>
      <Typography className={classes.text}>
        {cartItem.label || cartItem.combo_name || ""}
      </Typography>
      <Typography className={classes.countText}> x {cartItem.count}</Typography>
      <div className={classes.grow} />
      <Typography className={classes.text}>
        {CURRENCY.SIGN}
        {cartItem?.freeCount > 0
          ? getItemTotsalPrice(cartItem)
          : getOriginalPrice(total)}
      </Typography>
    </div>
  );
}
